import React from 'react';
import { Link } from 'react-router-dom';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import priorityImg from '../../assets/about/priority.png';
import './Priority.scss';

const Priority = () => {
    return (
        <section className='priority-section emergency-section' data-aos="fade-up" data-aos-duration="2000">
        <div className="container-fluid">
            <div className="row align-items-center">
                <div className="col-lg-6 col-md-6">
                    <div className="priority-img">
                        <img src="https://i.ibb.co/Z6zYK9Z1/339013899-1638232763347057-9025597554540742180-n.jpg" alt="Emergency" />
                    </div>
                </div>
                <div className="col-lg-6 col-md-6">
                    <div className="priority-text">
                        <SectionTitle 
                            subTitle="OUR PRIORITY" 
                            title="Our clients are our priority"
                            description="At our clinic, we understand the importance of dental health and prioritize our patients’ needs above all. Whether you need urgent care or routine dental checkups, our team is dedicated to providing exceptional service and ensuring your comfort and well-being at every visit."
                        />
    
                        <div className="theme-btn">
                            <Link to='/'>Book an appointment</Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    );
};

export default Priority;